import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderDropdownComponent } from '../../../../../../shared/components/header/header-dropdown/header-dropdown.component';
import { FrnFilingHeaderInfoComponent } from '../frn-filing-header-info/frn-filing-header-info.component';

@Component({
    selector: 'app-frn-filing-header',
    templateUrl: './frn-filing-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        HeaderDropdownComponent,
        FrnFilingHeaderInfoComponent,
    ],
})
export class FrnFilingHeaderComponent {}
